import React from "react";

function ExpenseReport({ expenseReport }) {
  return (
    <div>
      <table className="min-w-full overflow-y-visible bg-white  border-gray-200 rounded-md">
        {/* Table Head  */}
        <thead>
          <tr className="bg-gray-100 ">
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
              Sl No
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor ">
              Building Name
            </th>
            {[
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
              "January",
              "February",
              "March",
            ].map((month) => (
              <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor ">
                {month}
              </th>
            ))}
          </tr>
        </thead>

        {/* Table Body  */}
        <tbody>
          {expenseReport.length > 0 ? (
            expenseReport?.map((data, index) => (
              <tr
                key={index}
                className="border-b border-gray-200 hover:bg-gray-50"
              >
                <td className="py-4 px-6 ext-sm text-primaryTextColor">
                  {index + 1}
                </td>
                <td className="py-4 px-6 ext-sm text-primaryTextColor">
                  {data.buildingName}
                </td>
                {[
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                  "January",
                  "February",
                  "March",
                ].map((month, index) => (
                  <td
                    className="py-4 px-6 ext-sm text-primaryTextColor"
                    key={index}
                  >
                    {data[month]}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="14"
                className="py-40 px-6 text-lg text-center text-secondaryTextColor"
              >
                No Data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default ExpenseReport;
